import { styled } from '@mui/system'
import { colors, fontSizes, BORDER_RADIUSES } from '../../../Constants/consts'

export const FooterContainer = styled('footer')(({ theme }) => ({
  backgroundColor: colors.black,
  color: colors.gray.gray20,
  padding: theme.spacing(6, 8),
  marginTop: 'auto',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 4),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 2),
  },
}))

export const FooterContent = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr 1fr auto',
  gap: theme.spacing(6),
  maxWidth: 1400,
  margin: '0 auto',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'auto 1fr 1fr',
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gap: theme.spacing(4),
  },
}))

export const LogoSection = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  [theme.breakpoints.down('md')]: {
    gridColumn: '1 / -1',
    justifyContent: 'center',
  },
}))

export const Logo = styled('img')({
  width: 120,
  height: 'auto',
  filter: 'brightness(0) invert(1)',
})

export const FooterSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
})

export const SectionTitle = styled('h3')({
  fontSize: fontSizes.small,
  fontWeight: 700,
  letterSpacing: '0.5px',
  margin: 0,
  color: colors.gray.gray40,
})

export const LinkList = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
})

export const LinkItem = styled('li')({
  margin: 0,
})

export const FooterLink = styled('a')({
  color: colors.gray.gray20,
  textDecoration: 'none',
  fontSize: fontSizes.small,
  lineHeight: 1.5,
  transition: 'color 0.2s ease',
  '&:hover': {
    color: colors.white,
  },
  '&:focus': {
    outline: `2px solid ${colors.lightBlue}`,
    outlineOffset: 2,
    borderRadius: BORDER_RADIUSES.xSmall,
  },
})

export const AppStoreSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  [theme.breakpoints.down('lg')]: {
    gridColumn: '1 / -1',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 12,
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}))

export const AppStoreButton = styled('a')(({ theme }) => ({
  display: 'block',
  width: 160,
  height: 'auto',
  transition: 'opacity 0.2s ease',
  '&:hover': {
    opacity: 0.8,
  },
  '&:focus': {
    outline: `2px solid ${colors.lightBlue}`,
    outlineOffset: 4,
    borderRadius: BORDER_RADIUSES.small,
  },
  [theme.breakpoints.down('sm')]: {
    width: 140,
  },
}))

export const AppStoreBadge = styled('img')({
  width: '100%',
  height: 'auto',
  display: 'block',
})
